const getOpenAvailyBookingFromAppointment = (blocking) => blocking === void 0 ? false : !blocking;
export {
  getOpenAvailyBookingFromAppointment
};
